import { API_BASE_URL } from "./constants";

export const check = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Authentication check result:', data);

    if (!data.isAuthenticated || !data.accessToken) {
      console.error('Authentication check failed:', data.message);
      throw new Error(data.message);
    }
    
    return data;
  } catch (error) {
    console.error('Error checking authentication:', error);
    throw new Error('Failed to check authentication');
  }
};

export const logout = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Logout successful:', data);

    if (!data.success) {
      console.error('Logout failed:', data.message);
    }

    sessionStorage.removeItem('token');

    window.location.href = '/iniciar-sesion';
  } catch (error) {
    console.error('Error logging out the user:', error);
  }
};